<template>
  <div
    class="editor-additional__wrapper editor-wrapper text-container"
    :class="{ editable }"
  >
    <div class="editor-additional">
      <div><SvgIcon name="editor/additional" /></div>
      <EditorContentEditable
        :contenteditable="editable"
        placeholder="Текст"
        :text="text"
        :style="textAlignStyle"
        @blur="handleTextChange"
      />
    </div>
    <EditorAdditionalBlockEdit
      v-if="editable"
      class="additional-edit"
      @delete="$emit('delete')"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  editable: { type: Boolean, default: false },
  text: { type: [String, Number], default: '' },
  textAlign: { type: String, default: 'left' },
});

const emit = defineEmits(['update:text', 'delete']);

const textAlignStyle = computed(() => {
  return {
    'text-align': props.textAlign,
  };
});

const handleTextChange = (e) => {
  emit('update:text', e.target.innerText);
};
</script>
